import ErrorMessage from './error-message';
import buildError, { buildErrorContainer } from './error-template';
import NotFoundErrorContent from './not-found-error-content';
import Schema from './schema-error';

export const SchemaError = buildErrorContainer(Schema);
export const NotFoundError = buildError(NotFoundErrorContent);
export const CustomError = buildError(ErrorMessage);
export const GenericError = buildError();

export { default as ErrorMessage } from './error-message';
